<template>
  <div class="section-title" :class="classObj">
    <div class="section-title__side section-title__side_left">
      <div class="section-title__border section-title__border_left"></div>
    </div>
    <h2 class="section-title__content">
      <slot />
    </h2>
    <div class="section-title__side section-title__side_right">
      <div class="section-title__border section-title__border_right"></div>
      <div v-if="$slots.afterExtend" class="section-title__after-extend">
        <slot name="afterExtend" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    gradient: Boolean,
    darkened: Boolean,
    position: {
      type: String,
      default: "left",
      validator: val => ["left", "center"].includes(val)
    }
  },
  computed: {
    classObj() {
      return {
        "section-title_darkened": this.darkened,
        "section-title_gradient": this.gradient,
        [`section-title_${this.position}`]: this.position
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".section-title";
$shadow: 0 0 15px #fff;
$border: 1px solid colors(palette-7);

.section-title {
  position: relative;
  z-index: 1;
  display: flex;
  padding: 15px; //compensation of skew

  &__after-extend {
    position: absolute;
    left: 20px;
    top: calc(50% + 2px);
    transform: translateY(-50%);
  }

  &__content {
    position: relative;
    font-size: 32px;
    font-weight: normal;
    z-index: 4;
    text-transform: uppercase;
    text-shadow: $shadow, $shadow;
    flex-shrink: 0;
    text-align: center;
    padding: 0 45px;
    min-width: 300px;
    line-height: 25px;

    @include mobile() {
      font-size: 20px;
      min-width: 100px;
      padding: 0 30px;
    }
  }

  &__side {
    flex-grow: 1;
    position: relative;
  }

  &__border {
    transform: skew(-40deg);
    height: 100%;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 2px;
      background-color: colors(palette-3);
    }

    &_left {
      border-right: $border;
      border-bottom: $border;
      &::after {
        right: -11px;
      }
    }

    &_right {
      border-left: $border;
      border-top: $border;
      &::after {
        left: -11px;
      }
    }
  }

  &_left {
    justify-content: flex-start;
    #{$p}__side_left {
      max-width: 55px;

      @include mobile() {
        max-width: 15px;
      }
    }
  }

  &_center {
    justify-content: center;
  }
}
</style>
